import { DepartmentEditForm } from "./EditDepartment";
import { hasUserPermission } from "../utils/userPermissions";
import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from "react";
import { Alert, Button } from '@themesberg/react-bootstrap';
import { PageDepartmentsTable } from "../components/Tables";
import { DepartmentForm } from "./CreateDepartment";

export default () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingDepartmentId, setEditingDepartmentId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handleDepartmentCreated = (result) => {
    setShowCreateModal(false);
    setSuccessMessage(result.message || 'Department created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission("departments", "edit")) return;
    setSuccessMessage("");
    setEditingDepartmentId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingDepartmentId(null);
  };

  const handleDepartmentUpdated = result => {
    setEditingDepartmentId(null);
    setSuccessMessage(result.message || "Department updated successfully.");
    setRefreshKey(value => value + 1);
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">Departments</h2>
        </div>
        <PermissionGate module="departments" action="add"><Button
          variant="primary"
          className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none"
          onClick={() => { setSuccessMessage(""); setShowCreateModal(true); }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          Create Department
        </Button></PermissionGate>
      </div>

      {successMessage && (
        <Alert variant="success" dismissible onClose={() => setSuccessMessage("")}>
          {successMessage}
        </Alert>
      )}

      <div className="my-auto">
        <PageDepartmentsTable refreshKey={refreshKey} onEditDepartment={openEditModal} />
      </div>

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-department-title"
        title="Create Department"
        description="Organize your team with a new department."
        icon={faSitemap}
        size="lg"
      >
        {showCreateModal && (
          <DepartmentForm
            onSuccess={handleDepartmentCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingDepartmentId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-department-title"
        title="Edit Department"
        description="Update the department name and company assignments."
        icon={faSitemap}
        size="lg"
      >
        {editingDepartmentId !== null && (
          <DepartmentEditForm key={editingDepartmentId} departmentId={editingDepartmentId}
            onSuccess={handleDepartmentUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </>
  );
};
